import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
import { CalendarIcon, ClockIcon, MapPinIcon } from 'lucide-react';
export function BookingPage() {
  return <Layout data-id="element-243">
      <section className="py-24 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-244">
        <div className="max-w-7xl mx-auto text-center" data-id="element-245">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-block bg-espresso/10 text-espresso px-4 py-2 font-bold uppercase tracking-widest text-xs mb-6" data-id="element-246">
            Schedule Now
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-5xl md:text-7xl font-bold mb-8" data-id="element-247">
            Book Your{' '}
            <span className="italic font-serif font-normal text-espresso" data-id="element-248">
              Consultation
            </span>
            .
          </motion.h1>
        </div>
      </section>

      <section className="py-24 px-6 bg-white" data-id="element-249">
        <div className="max-w-4xl mx-auto" data-id="element-250">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-251">
            {/* Info */}
            <div className="space-y-8" data-id="element-252">
              <div className="p-6 border-3 border-charcoal bg-alabaster" data-id="element-253">
                <CalendarIcon className="w-8 h-8 text-espresso mb-4" data-id="element-254" />
                <h3 className="font-bold uppercase tracking-widest text-xs mb-2" data-id="element-255">
                  Availability
                </h3>
                <p className="text-sm text-charcoal/60" data-id="element-256">
                  Monday — Friday
                  <br data-id="element-257" />
                  8:00 AM — 6:00 PM
                </p>
              </div>
              <div className="p-6 border-3 border-charcoal" data-id="element-258">
                <ClockIcon className="w-8 h-8 text-espresso mb-4" data-id="element-259" />
                <h3 className="font-bold uppercase tracking-widest text-xs mb-2" data-id="element-260">
                  Duration
                </h3>
                <p className="text-sm text-charcoal/60" data-id="element-261">
                  Initial consultations typically take 45-60 minutes.
                </p>
              </div>
              <div className="p-6 border-3 border-charcoal" data-id="element-262">
                <MapPinIcon className="w-8 h-8 text-espresso mb-4" data-id="element-263" />
                <h3 className="font-bold uppercase tracking-widest text-xs mb-2" data-id="element-264">
                  Location
                </h3>
                <p className="text-sm text-charcoal/60" data-id="element-265">
                  In-home or virtual via photo analysis.
                </p>
              </div>
            </div>

            {/* Form Placeholder */}
            <div className="lg:col-span-2 border-3 border-charcoal p-10 bg-alabaster/30" data-id="element-266">
              <h2 className="text-2xl font-bold mb-8" data-id="element-267">Select a Date & Time</h2>
              <div className="space-y-6" data-id="element-268">
                <div className="grid grid-cols-2 gap-4" data-id="element-269">
                  <input type="date" className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors" data-id="element-270" />
                  <select className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors" data-id="element-271">
                    <option data-id="element-272">Morning (8AM - 12PM)</option>
                    <option data-id="element-273">Afternoon (12PM - 4PM)</option>
                    <option data-id="element-274">Evening (4PM - 6PM)</option>
                  </select>
                </div>
                <input type="text" placeholder="FULL NAME" className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors" data-id="element-275" />
                <input type="email" placeholder="EMAIL ADDRESS" className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors" data-id="element-276" />
                <textarea placeholder="PROJECT DETAILS" className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors min-h-[120px]" data-id="element-277"></textarea>
                <button className="w-full bg-charcoal text-alabaster py-5 font-bold uppercase tracking-[0.2em] text-sm hover:bg-espresso transition-colors" data-id="element-278">
                  Confirm Appointment
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}